module.exports = __webpack_public_path__ + "img/ml3060.be7cf8b0.png";